<app-text-field
    #input
    class="w-full"
    [placeholderIcon]="'search'"
    [placeholder]="placeholderTranslationKey | translate"
    [clearButtonEnabled]="true"
    [ngModel]="text$ | async"
    (ngModelChange)="handleChangedText($event)"
>
</app-text-field>
